/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs */

const en_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployment`)
};

const ar_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشر`)
};

const bn_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয়মেন্ট`)
};

const de_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitstellung`)
};

const es_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implementación`)
};

const fr_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement`)
};

const pt_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantação`)
};

const zh_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署`)
};

const tr_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dağıtım`)
};

const ru_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развертывание`)
};

const pl_svc_full_stack_web_apps_work_0_metric_2_label = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie`)
};

/**
* | output |
* | --- |
* | "Deployment" |
*
* @param {Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_work_0_metric_2_label = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Work_0_Metric_2_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
	return en_svc_full_stack_web_apps_work_0_metric_2_label(inputs)
});
export { svc_full_stack_web_apps_work_0_metric_2_label as "svc_full-stack-web-apps_work_0_metric_2_label" }